<template>
 <div>
  <el-tag class="flex-bewteen" style="height: 32px;" v-if="tagFlag" :type="type"   :disable-transitions="false"  >
    <div class="Flex">
      <i  class="iconhuice" :class="{'icon-xiaoxi':type==='','icon-cuowu':type==='danger','icon-jinggao':type==='warning'}"/>
      <span class="tag-content ml08">{{content}}</span>
    </div>
    <i v-if="iconGuanbi" class="iconhuice icon-guanbi"  @click="close"></i>
  </el-tag>
 </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    iconGuanbi: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tagFlag: true
    }
  },

  mounted() {

  },

  methods: {
    close() {
      this.tagFlag = !this.tagFlag
      this.$emit('close', this.tagFlag)
    }
  }
}
</script>

<style scoped lang='scss'>
.Flex{
  display: flex;
  align-items: center;
  .icon-xiaoxi{
    // transform: scale(0.9)
    font-size: 14px;
  }
}
.flex-bewteen{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .icon-guanbi{
    // transform: scale(0.6)
    font-size: 9px;
  }
}
.tag-content{
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: $G9;
}
</style>
